var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#plus_svg__clip0_35_697)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#221F20",
  d: "M12.089 14.457H.26v2.628h11.828v-2.628ZM31.83 14.457H20.014v2.628h11.817v-2.628Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5A173",
  d: "M17.346 0h-2.629v31.542h2.629V0Z",
  className: "plus_svg__vertical"
}))));
export default SvgPlus;